import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AppShell from './AppShell';
import ProtectedRoute from './ProtectedRoute';
import AccessRoute from './AccessRoute';
import StudentPortalRoute from './StudentPortalRoute';
import StudentPortalShell from './StudentPortalShell';
import PackRoute from './PackRoute';
import DashboardPage from '../pages/DashboardPage';
import StudentsPage from '../pages/StudentsPage';
import ProgrammesManagePage from '../pages/ProgrammesManagePage';
import ProgrammesCreatePage from '../pages/ProgrammesCreatePage';
import ProgrammesEditPage from '../pages/ProgrammesEditPage';
import StudentProfilePage from '../pages/StudentProfilePage';
import StudentDashboardPage from '../pages/StudentDashboardPage';
import StudentFormPage from '../pages/StudentFormPage';
import StudentCertificateCreatePage from '../pages/StudentCertificateCreatePage';
import StudentDocumentCreatePage from '../pages/StudentDocumentCreatePage';
import AttendancePage from '../pages/AttendancePage';
import InventoryPage from '../pages/InventoryPage';
import InventoryDetailPage from '../pages/InventoryDetailPage';
import InventoryCreatePage from '../pages/InventoryCreatePage';
import ProgrammesPage from '../pages/ProgrammesPage';
import ReportsPage from '../pages/ReportsPage';
import SettingsPage from '../pages/SettingsPage';
import ResetPasswordPage from '../pages/ResetPasswordPage';
import LoginPage from '../pages/LoginPage';
import UserProfilePage from '../pages/UserProfilePage';
import InternalMessagesPage from '../pages/InternalMessagesPage';
import ExternalMessagesPage from '../pages/ExternalMessagesPage';
import StudentPortalLoginPage from '../pages/StudentPortalLoginPage';
import StudentPortalResetPage from '../pages/StudentPortalResetPage';
import StudentPortalDashboardPage from '../pages/StudentPortalDashboardPage';
import StudentPortalTimetablePage from '../pages/StudentPortalTimetablePage';
import StudentPortalTimetableDetailPage from '../pages/StudentPortalTimetableDetailPage';
import StudentPortalAssignmentsPage from '../pages/StudentPortalAssignmentsPage';
import StudentPortalNotificationsPage from '../pages/StudentPortalNotificationsPage';
import StudentPortalSupportPage from '../pages/StudentPortalSupportPage';
import StudentPortalEmergencyPage from '../pages/StudentPortalEmergencyPage';
import StudentPortalJournalPage from '../pages/StudentPortalJournalPage';
import StudentPortalPointsPage from '../pages/StudentPortalPointsPage';
import BroadcastsPage from '../pages/BroadcastsPage';
import StaffPage from '../pages/StaffPage';
import StaffFormPage from '../pages/StaffFormPage';
import StaffDetailPage from '../pages/StaffDetailPage';
import IncidentsPage from '../pages/IncidentsPage';
import IncidentDetailPage from '../pages/IncidentDetailPage';
import IncidentCreatePage from '../pages/IncidentCreatePage';
import SafeguardingReportPage from '../pages/SafeguardingReportPage';
import ActivitiesCreatePage from '../pages/ActivitiesCreatePage';
import ActivitiesEditPage from '../pages/ActivitiesEditPage';

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/student-portal/login" element={<StudentPortalLoginPage />} />
        <Route path="/student-portal/reset" element={<StudentPortalResetPage />} />
        <Route
          element={
            <StudentPortalRoute>
              <StudentPortalShell />
            </StudentPortalRoute>
          }
        >
          <Route path="/student-portal" element={<StudentPortalDashboardPage />} />
          <Route path="/student-portal/timetable" element={<StudentPortalTimetablePage />} />
          <Route path="/student-portal/timetable/:type/:id" element={<StudentPortalTimetableDetailPage />} />
          <Route path="/student-portal/assignments" element={<StudentPortalAssignmentsPage />} />
          <Route path="/student-portal/notifications" element={<StudentPortalNotificationsPage />} />
          <Route path="/student-portal/journal" element={<StudentPortalJournalPage />} />
          <Route
            path="/student-portal/rewards"
            element={
              <PackRoute pack="rewards_points">
                <StudentPortalPointsPage />
              </PackRoute>
            }
          />
          <Route path="/student-portal/support" element={<StudentPortalSupportPage />} />
          <Route path="/student-portal/emergency" element={<StudentPortalEmergencyPage />} />
        </Route>
        <Route path="/staff/login" element={<LoginPage />} />
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route
            path="/dashboard"
            element={
              <AccessRoute module="dashboard">
                <DashboardPage />
              </AccessRoute>
            }
          />
          <Route
            path="/students"
            element={
              <AccessRoute module="students">
                <StudentsPage />
              </AccessRoute>
            }
          />
          <Route
            path="/students/enrol"
            element={
              <AccessRoute module="students">
                <StudentFormPage />
              </AccessRoute>
            }
          />
          <Route path="/students/new" element={<Navigate to="/students/enrol" replace />} />
          <Route path="/students/search" element={<Navigate to="/students" replace />} />
          <Route
            path="/students/:id/edit"
            element={
              <AccessRoute module="students">
                <StudentFormPage />
              </AccessRoute>
            }
          />
          <Route
            path="/students/:id/certificates/new"
            element={
              <AccessRoute module="students">
                <StudentCertificateCreatePage />
              </AccessRoute>
            }
          />
          <Route
            path="/students/:id/documents/new"
            element={
              <AccessRoute module="students">
                <StudentDocumentCreatePage />
              </AccessRoute>
            }
          />
          <Route
            path="/students/:id/dashboard"
            element={
              <AccessRoute module="students">
                <StudentDashboardPage />
              </AccessRoute>
            }
          />
          <Route
            path="/students/:id/profile"
            element={
              <AccessRoute module="students">
                <StudentProfilePage />
              </AccessRoute>
            }
          />
          <Route path="/students/:id" element={<Navigate to="dashboard" replace />} />
          <Route path="/students/in-review" element={<Navigate to="/students?view=in-review" replace />} />
          <Route path="/students/high-risk" element={<Navigate to="/students?view=high-risk" replace />} />
          <Route path="/students/attendance-flags" element={<Navigate to="/students?view=attendance" replace />} />
          <Route path="/students/outstanding-documents" element={<Navigate to="/students?view=compliance" replace />} />
          <Route path="/students/outstanding-finance" element={<Navigate to="/students?view=compliance" replace />} />
          <Route path="/students/active-safeguarding" element={<Navigate to="/students?view=safeguarding" replace />} />
          <Route
            path="/safeguarding/new"
            element={
              <AccessRoute module="safeguarding">
                <SafeguardingReportPage />
              </AccessRoute>
            }
          />
          <Route
            path="/attendance"
            element={
              <AccessRoute module="attendance">
                <AttendancePage />
              </AccessRoute>
            }
          />
          <Route
            path="/support-workers"
            element={
              <AccessRoute module="support-workers">
                <StaffPage />
              </AccessRoute>
            }
          />
          <Route
            path="/support-workers/new"
            element={
              <AccessRoute module="support-workers">
                <StaffFormPage />
              </AccessRoute>
            }
          />
          <Route
            path="/support-workers/:id"
            element={
              <AccessRoute module="support-workers">
                <StaffDetailPage />
              </AccessRoute>
            }
          />
          <Route
            path="/support-workers/:id/edit"
            element={
              <AccessRoute module="support-workers">
                <StaffFormPage />
              </AccessRoute>
            }
          />
          <Route path="/staff" element={<Navigate to="/support-workers" replace />} />
          <Route
            path="/inventory"
            element={
              <AccessRoute module="inventory">
                <InventoryPage />
              </AccessRoute>
            }
          />
          <Route
            path="/inventory/new"
            element={
              <AccessRoute module="inventory">
                <InventoryCreatePage />
              </AccessRoute>
            }
          />
          <Route
            path="/inventory/:id"
            element={
              <AccessRoute module="inventory">
                <InventoryDetailPage />
              </AccessRoute>
            }
          />
          <Route
            path="/incidents"
            element={
              <AccessRoute module="incidents">
                <IncidentsPage />
              </AccessRoute>
            }
          />
          <Route
            path="/incidents/new"
            element={
              <AccessRoute module="incidents">
                <IncidentCreatePage />
              </AccessRoute>
            }
          />
          <Route
            path="/incidents/:id"
            element={
              <AccessRoute module="incidents">
                <IncidentDetailPage />
              </AccessRoute>
            }
          />
          <Route
            path="/programmes"
            element={
              <AccessRoute module="programmes">
                <ProgrammesPage />
              </AccessRoute>
            }
          />
          <Route
            path="/activities/new"
            element={
              <AccessRoute module="programmes">
                <ActivitiesCreatePage />
              </AccessRoute>
            }
          />
          <Route
            path="/activities/:id/edit"
            element={
              <AccessRoute module="programmes">
                <ActivitiesEditPage />
              </AccessRoute>
            }
          />
          <Route
            path="/programmes/overview"
            element={
              <AccessRoute module="programmes">
                <ProgrammesManagePage />
              </AccessRoute>
            }
          />
          <Route
            path="/programmes/overview/new"
            element={
              <AccessRoute module="programmes">
                <ProgrammesCreatePage />
              </AccessRoute>
            }
          />
          <Route
            path="/programmes/overview/:id/edit"
            element={
              <AccessRoute module="programmes">
                <ProgrammesEditPage />
              </AccessRoute>
            }
          />
          <Route path="/programmes/manage" element={<Navigate to="/programmes/overview" replace />} />
          <Route path="/programmes/manage/new" element={<Navigate to="/programmes/overview/new" replace />} />
          <Route
            path="/reports"
            element={
              <AccessRoute module="reports">
                <ReportsPage />
              </AccessRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <AccessRoute module="settings">
                <SettingsPage />
              </AccessRoute>
            }
          />
          <Route
            path="/broadcasts"
            element={
              <AccessRoute module="broadcasts">
                <BroadcastsPage />
              </AccessRoute>
            }
          />
          <Route
            path="/messages"
            element={
              <AccessRoute module="messages">
                <InternalMessagesPage />
              </AccessRoute>
            }
          />
          <Route
            path="/messages/external"
            element={
              <AccessRoute module="external-messages">
                <ExternalMessagesPage />
              </AccessRoute>
            }
          />
          <Route path="/profile" element={<UserProfilePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
